var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-control-wrapper",class:_vm.styleClass,on:{"click":_vm.goToChat}},[_c('i',{staticClass:"icon icon-mail"}),_c('div',{staticClass:"chat-control-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }